import { Routes } from '@angular/router';
import { LayoutComponent } from '../layout/layout.component';

import { AuthGuardService } from '../auth/auth-guard/auth-guard.service';
import { AuthCallbackComponent } from '../auth/auth-callback/auth-callback.component';

import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { Error404Component } from './pages/error404/error404.component';
import { Error500Component } from './pages/error500/error500.component';
import { DemoComponent } from './pages/demos/demos.component';
import { BotTestComponent } from './pages/bot/bot.component';
import { BotAppComponent } from './pages/botapp/botapp.component';
import { BotTeamsTabComponent } from './pages/teamstab/teamstab.component';

import { SuccessComponent } from './pages/success/success.component';

import { NotFoundRedirectComponent } from './notfound-redirect.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    data: {
      privilege: 'User',
    },
    children: [
      {
        path: '',
        redirectTo: 'launchpad',
        data: {
          privilege: 'User',
        },
        pathMatch: 'full',
      },
      {
        path: '',
        loadChildren: () =>
          import('./bots/bots.module').then((m) => m.BotsModule),
        data: {
          privilege: 'User',
        },
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./account/account.module').then((m) => m.AccountModule),
        data: {
          privilege: 'User',
        },
      },

      {
        path: 'connectors',
        loadChildren: () =>
          import('./connectors/connectors.module').then(
            (m) => m.ConnectorsModule
          ),
        data: {
          privilege: 'User',
        },
      },
      {
        path: 'organization',
        loadChildren: () =>
          import('./organization/organization.module').then(
            (m) => m.OrganizationModule
          ),
        data: {
          privilege: 'User',
        },
      },
      {
        path: 'playbook',
        loadChildren: () =>
          import('./playbook/playbook.module').then((m) => m.PlaybookModule),
        data: {
          privilege: 'User',
        },
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./users/users.module').then((m) => m.UsersModule),
        data: {
          privilege: 'User',
        },
      },
      // CHAT-856: the SuperAdmin tenant directory that replaces the header's inline
      // tenant <select>. Gated here as well as at the menu, so the route cannot be
      // reached by typing /partners without the privilege.
      {
        path: 'partners',
        canActivate: [AuthGuardService],
        data: {
          privilege: 'SuperAdmin',
        },
        loadChildren: () =>
          import('./partners/partners.module').then((m) => m.PartnersModule),
      },
      {
        path: 'chat-queue',
        loadChildren: () =>
          import('./operator-chat/chat-queue/chat-queue.module').then(
            (m) => m.ChatQueueModule
          ),
        data: {
          privilege: 'User',
        },
      },
      {
        path: 'operator-chat',
        loadChildren: () =>
          import('./operator-chat/operator-chat.module').then(
            (m) => m.OperatorChatModule
          ),
        data: {
          privilege: 'Operator',
        },
      },
    ],
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'setup',
        loadChildren: () =>
          import('./setup/setup.module').then((m) => m.SetupModule),
      },
    ],
  },
  // Not lazy-loaded routes
  { path: 'maintenance', component: MaintenanceComponent },
  { path: 'success', component: SuccessComponent },
  { path: 'fail', component: SuccessComponent }, // Reuse SuccessComponent for error states
  { path: '404', component: Error404Component },
  { path: '500', component: Error500Component },

  { path: 'demos/:id', component: DemoComponent },
  { path: 'bottest/:id', component: BotTestComponent },
  { path: 'botapp/:id', component: BotAppComponent },
  { path: 'teamstab/:id', component: BotTeamsTabComponent },

  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
  },

  // Not found
  {
    path: '**',
    component: NotFoundRedirectComponent,
  },
];
